import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import * as i2 from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PrimengLibraryModule } from 'primeng-library';

class LibPreviewInvoiceService {
    constructor(http) {
        this.http = http;
    }
    getInvoicePDFDetails(payload, formDataId) {
        const url = formDataId
            ? `/vd/formBuilder/client/invoice/document/generate?formDataId=${formDataId}`
            : `/vd/formBuilder/client/invoice/document/generate`;
        return this.http.post(url, payload).pipe(map((response) => {
            if (response.status === 200) {
                return (response === null || response === void 0 ? void 0 : response.data) || null;
            }
            else {
                return null;
            }
        }));
    }
}
LibPreviewInvoiceService.ɵfac = function LibPreviewInvoiceService_Factory(t) { return new (t || LibPreviewInvoiceService)(i0.ɵɵinject(i1.HttpClient)); };
LibPreviewInvoiceService.ɵprov = i0.ɵɵdefineInjectable({ token: LibPreviewInvoiceService, factory: LibPreviewInvoiceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPreviewInvoiceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class LibPreviewInvoiceComponent {
    constructor(libApiService) {
        this.libApiService = libApiService;
        this.pdfSrc = '';
        this.emailTo = '';
        this.emailContent = "";
    }
    ngOnInit() {
        this.getInvoicePreview();
    }
    updateHtmlRenderObj() {
        const keys = Object.keys(this.group.value);
        keys.forEach(key => {
            const htmlRenderObjIndex = this.getHtmlRenderObjIndex(key);
            if (htmlRenderObjIndex > -1) {
                const columnObj = this.htmlRenderObj[htmlRenderObjIndex];
                const layoutCode = columnObj === null || columnObj === void 0 ? void 0 : columnObj.layoutCode;
                const value = this.group.value[key];
                switch (layoutCode) {
                    case 'CustomGridEditor':
                        columnObj.gridValues = value.gridValues;
                        break;
                    case 'VdSwitchGroupComponent':
                        this.updateSwitchGroupValue(columnObj, value);
                        break;
                    case 'CustomQuestionsGroupComponent':
                        columnObj.questionCheck = value;
                        columnObj.value = value;
                        break;
                    case 'CustomCalenderComponent':
                        columnObj.value = value || '';
                        break;
                    case 'LibTemplateViewer':
                        if (columnObj.name === 'TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf') {
                            columnObj.value = {
                                emailTo: value.emailTo || [],
                                emailCC: value.emailCC || [],
                                emailSubject: value.emailSubject || '',
                                emailTemplateContent: value.emailTemplateContent || '',
                                templateId: value.templateId || ''
                            };
                        }
                        break;
                    default:
                        columnObj.value = value;
                        break;
                }
            }
        });
    }
    getHtmlRenderObjIndex(key) {
        const findIndexCondition = x => ['VdEadLibraryComponent', 'VdCountryStateComponent'].includes(x.layoutCode)
            ? x.groupName === key
            : x.name === key;
        return this.htmlRenderObj.findIndex(findIndexCondition);
    }
    updateSwitchGroupValue(columnObj, value) {
        const switchGridProps = columnObj.groupElementProperty;
        let additionalInfo = '';
        if ((switchGridProps === null || switchGridProps === void 0 ? void 0 : switchGridProps.whenTextAreaShown) === 'off') {
            additionalInfo = value.switch_field === true ? '' : value.additional_info_for_switch_field;
        }
        else if ((switchGridProps === null || switchGridProps === void 0 ? void 0 : switchGridProps.whenTextAreaShown) === 'on') {
            additionalInfo = value.switch_field === false ? '' : value.additional_info_for_switch_field;
        }
        else {
            additionalInfo = value.additional_info_for_switch_field;
        }
        columnObj.value = {
            switch_field: value.switch_field,
            additional_info_for_switch_field: additionalInfo
        };
        columnObj.questionCheck = value.switch_field;
    }
    createPayload() {
        const payload = {};
        payload.companyId = 'companyId' in sessionStorage ? parseInt(sessionStorage.getItem('companyId')) : null;
        const formDateJsonPayload = this.htmlRenderObj;
        payload.formDateJson = JSON.stringify(formDateJsonPayload);
        return payload;
    }
    getInvoicePreview() {
        var _a;
        this.updateHtmlRenderObj();
        const payload = this.createPayload();
        this.formData = JSON.parse(payload.formDateJson);
        console.log(this.group);
        this.emailTo = (this.group.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].emailTo
            && ((_a = this.group.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].emailTo) === null || _a === void 0 ? void 0 : _a.length) > 0) ? this.group.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].emailTo.join(',') : '';
        //  this.emailContent = (this.group?.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].emailTemplateContent) ? this.group?.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].
        //  emailTemplateContent
        //  .replace(/\n/g,'<br />') : '';
        //  this.emailSubject =  (this.group?.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].emailSubject) ? this.group?.value['TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf'].emailSubject : '';
        this.formDataId = 'getFilesId' in sessionStorage ? parseInt(sessionStorage.getItem('getFilesId')) : null;
        this.libApiService.getInvoicePDFDetails(this.formData, this.formDataId).subscribe(data => {
            if (data) {
                let dataSlice = data.filePath.split('/var/imagility/uploads/');
                this.emailContent = data.emailBody;
                this.emailSubject = data.emailSubject;
                this.pdfSrc = environment.docs + dataSlice[1];
            }
        });
    }
}
LibPreviewInvoiceComponent.ɵfac = function LibPreviewInvoiceComponent_Factory(t) { return new (t || LibPreviewInvoiceComponent)(i0.ɵɵdirectiveInject(LibPreviewInvoiceService)); };
LibPreviewInvoiceComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibPreviewInvoiceComponent, selectors: [["lib-preview-invoice"]], inputs: { group: "group", inputParams: "inputParams", htmlRenderObj: "htmlRenderObj" }, decls: 24, vars: 5, consts: [[1, "row", "bgHighlight"], [1, "col-12"], [1, "view_candidate_details_heading"], [1, "view_candidate_details_content"], [1, "col-12", "mt-1"], [1, "view_candidate_details_content", 3, "innerHTML"], [1, "col-12", "mt-2"], [1, "row"], [1, "col", 2, "width", "680px"], ["height", "80vh", "useBrowserLocale", "true", 1, "letter-pdf", 2, "width", "100%", 3, "src"]], template: function LibPreviewInvoiceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "p", 2);
        i0.ɵɵtext(3, " From ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "p", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "p", 2);
        i0.ɵɵtext(8, " To ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "p", 3);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 4);
        i0.ɵɵelementStart(12, "p", 2);
        i0.ɵɵtext(13, " Subject ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "p", 3);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 4);
        i0.ɵɵelementStart(17, "p", 2);
        i0.ɵɵtext(18, " Email Content ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "p", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 6);
        i0.ɵɵelementStart(21, "div", 7);
        i0.ɵɵelementStart(22, "div", 8);
        i0.ɵɵelement(23, "ngx-extended-pdf-viewer", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.group == null ? null : ctx.group.value["CREATE_INVOICE"] == null ? null : ctx.group.value["CREATE_INVOICE"].billedByEmail) ? ctx.group == null ? null : ctx.group.value["CREATE_INVOICE"] == null ? null : ctx.group.value["CREATE_INVOICE"].billedByEmail : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.emailTo, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.emailSubject, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("innerHTML", ctx.emailContent, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", ctx.pdfSrc);
    } }, directives: [i2.NgxExtendedPdfViewerComponent], styles: [".headTbl[_ngcontent-%COMP%]{background-color:#edf4fb;height:40px;padding:10px}.positionDetailsSection[_ngcontent-%COMP%]{background-color:#f7faff;color:#4a4a4a;padding:10px}.labelHeading[_ngcontent-%COMP%]{font-size:15px;word-wrap:break-word}.labelHeading.headlbl[_ngcontent-%COMP%]{font-size:13px;font-weight:600;white-space:nowrap}h5[_ngcontent-%COMP%]{color:#6d6d6d;font-weight:600}.view_candidate_details_heading[_ngcontent-%COMP%]{font-weight:600;margin-bottom:0;margin-left:12px}.view_candidate_details_content[_ngcontent-%COMP%]{font-size:14px;margin-bottom:0;margin-left:12px}.pdf_section[_ngcontent-%COMP%]{border-top:2px dashed #ccc;padding-top:30px}.bgHighlight[_ngcontent-%COMP%]{background:#f7faff;padding-top:10px;padding-bottom:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPreviewInvoiceComponent, [{
        type: Component,
        args: [{
                selector: 'lib-preview-invoice',
                templateUrl: 'lib-preview-invoice.component.html',
                styleUrls: ['lib-preview-invoice.component.scss']
            }]
    }], function () { return [{ type: LibPreviewInvoiceService }]; }, { group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], htmlRenderObj: [{
            type: Input
        }] }); })();

class LibPreviewInvoiceModule {
}
LibPreviewInvoiceModule.ɵfac = function LibPreviewInvoiceModule_Factory(t) { return new (t || LibPreviewInvoiceModule)(); };
LibPreviewInvoiceModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibPreviewInvoiceModule });
LibPreviewInvoiceModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            NgxExtendedPdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibPreviewInvoiceModule, { declarations: [LibPreviewInvoiceComponent], imports: [PrimengLibraryModule,
        NgxExtendedPdfViewerModule], exports: [LibPreviewInvoiceComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPreviewInvoiceModule, [{
        type: NgModule,
        args: [{
                declarations: [LibPreviewInvoiceComponent],
                imports: [
                    PrimengLibraryModule,
                    NgxExtendedPdfViewerModule
                ],
                exports: [LibPreviewInvoiceComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-preview-invoice
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibPreviewInvoiceComponent, LibPreviewInvoiceModule, LibPreviewInvoiceService };
//# sourceMappingURL=lib-preview-invoice.js.map
